<template>
  <div
    class="message-item"
    :class="{ reply: replyTo, quoted: quotedMessage, 'fix-edge':message.quotedMessage }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    v-show="loaded"
  >
    <div class="message-item__user-container" :class="{'active': ifShowUserInfo}">
      <!-- user info when clicking user icon -->
      <scale-transition customClasses="tranform__top-left">
        <div class="message-item__user-info" v-show="ifShowUserInfo" v-click-outside="closeUserInfo">
          <p><b>{{message.author.firstName}} {{message.author.lastName}}</b></p>
          <p class="pronouns">{{message.author.pronouns ? `(${message.author.pronouns})` : ''}}</p>
          <div class="message-item__user-fields" v-if="message.author.field1 || message.author.field2">
            <p v-if="message.author.field1">
              {{ message.author.field1 }}
            </p>
            <p v-if="message.author.field2">
              {{ message.author.field2 }}
            </p>
          </div>
        </div>
      </scale-transition>
      <!-- user icon -->
      <UserIcon class="message-item__user-icon" @click="toggleShowUserInfo" :userId="message.author.id" userStatus="dark" />

    </div>

    <fade-transition>
      <div class="message-item__hover" v-show="hover">
        <img v-show="ifCanDelete" src="@/assets/chat-icons/delete.svg" alt="delete chat message" @click="deleteAMessage" />
      </div>
    </fade-transition>
    <div class="message-item__info">
      <chat-message-name-header :message="message"
                                :showUserInfo="toggleShowUserInfo"
      />
    </div>
    <p class="message-item__message" v-html="message.content" :style="messageStyles" >
    </p>
    <chat-reactions v-if="!replyTo && !quotedMessage"
                    :reactions="reactions"
                    :totalReactions="totalReactions"
                    :messageId="message.id"
                    :replyToMessage="replyToMessage"
    />
  </div>
</template>

<script>
import UserIcon from '@/components/UserIcon.vue';
import ChatMessageNameHeader from './ChatMessageNameHeader.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import ScaleTransition from '@/components/transitions/ScaleTransition.vue';
import { mapActions } from 'vuex';
import ChatReactions from './ChatReactions.vue';
export default {
  name: 'ChatMessage',
  components: {
    UserIcon,
    ChatMessageNameHeader,
    FadeTransition,
    ScaleTransition,
    ChatReactions
  },
  props: {
    message: Object,
    currentUsersData: Object,
    quotedMessage: Boolean
  },
  data() {
    return {
      hover: false,
      loaded: false,
      showReact:false,
      messageStyles: {
        'color': 'white !important',
      },
      ifShowUserInfo: false,
      lastOpenedUserInfo: 0
    };
  },
  computed: {
    replyTo() {
      //if this message is a reply to another message
      return this.message.replyTo || false;
    },
    reactions() {
      return this.message.reactions || []
    },
    totalReactions() {
      return this.message.totalReactions || 0
    },
    ifCanDelete() {
      return this.message.canDelete
    }
  },
  methods: {
    ...mapActions(['replyToMessageHandler', 'deleteMessageHandler']),
    replyToMessage() {
      this.replyToMessageHandler(this.message);
    },
    deleteAMessage() {
      this.deleteMessageHandler({messageId:this.message.id});
    },
    toggleShowUserInfo() {
      if(!this.lastOpenedUserInfo || Date.now() > this.lastOpenedUserInfo + 100) {
        this.ifShowUserInfo = !this.ifShowUserInfo;
        this.lastOpenedUserInfo = Date.now()
      }
    },
    closeUserInfo() {
      if(this.ifShowUserInfo && Date.now() > this.lastOpenedUserInfo + 300) {
        this.ifShowUserInfo = false
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loaded = true;
    });
  }
};
</script>
<style lang="scss" scoped>
@import '~@/scss/components/sidebar/chat_message.scss';
</style>

<style scoped>
/* the >>> is a feature of vue-loader, so it isn't supported when using SCSS */
.message-item >>> a {
  color: white;
  transition: color 0.1s ease;
}
.message-item >>> a:hover {
  color: #D8D8D8;
}
</style>
